import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface SyncButtonProps {
	onClick: () => void;
	loading: boolean;
}
export function SyncButton(props: SyncButtonProps) {
	return (
		<Button onClick={props.onClick} type="link" className="pt-1">
			<SyncOutlined style={{ fontSize: '20px', height: '20px' }} spin={props.loading} />
		</Button>
	);
}
